import { usePetitionDetailsPageFcm } from 'src/app/pages/petitionDetails/pageContext';

export function useShowNewlyCreatedPetitions(): boolean {
	const { newlyCreatedPetitionsEnabled } = usePetitionDetailsPageFcm();

	return newlyCreatedPetitionsEnabled;
}
